import { Button, Grid, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { useNavigate } from "react-router-dom";
import { ROOT } from "../../global/urlMapping";

export const PageNotFound = () => {

    const navigate = useNavigate();

    return (
        <>
            <Box className="bg"
                sx={{
                    flexGrow: 1,
                    overflow: 'hidden',
                    with: "100%"
                }}>
                <Box sx={{ x: 'auto' }}>
                    <Grid container wrap="nowrap" spacing={2}>
                        <Grid item xs zeroMinWidth>

                            <Box sx={{ width: "100%", height: "150px", display: "flex" }}>
                                <Typography
                                    component='h1'
                                    sx={{
                                        color: "#005397",
                                        margin: "auto",
                                        textAlign: "center",
                                        fontSize: { xs: "25px", md: "40px" },
                                        fontWeight: 700,
                                    }}
                                >
                                    Pagina non trovata
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>

                <Box sx={{ my: 4, mx: 'auto', paddingBottom: "20vh" }}>
                    <Grid container wrap="nowrap" spacing={2}>
                        <Grid item xs zeroMinWidth>
                            <Box
                                sx={{
                                    width: "80%",
                                    margin: "auto",
                                    display: "flex",
                                    flexDirection: "column",
                                }}
                            >
                                <Box
                                    sx={{
                                        width: "100%",
                                        display: "flex",
                                        margin: "auto",
                                        flexDirection: "column",
                                        backgroundColor: "transparent ",
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            color: "#005397",
                                            fontSize: { xs: "25px", md: "35px" },
                                            fontWeight: 700,
                                            margin: "auto",
                                            textAlign: "center",
                                            width: "60%",
                                            wordWrap: "inherit",
                                        }}
                                    >
                                        La pagina richiesta non esiste.
                                    </Typography>
                                </Box>

                                <Box
                                    sx={{
                                        width: "100%",
                                        backgroundColor: "trasparent",
                                        display: "flex",
                                    }}
                                >
                                    <Button
                                        onClick={() => navigate(ROOT)}
                                        variant="contained"
                                        sx={{
                                            height: "auto",
                                            borderRadius: "20px !important",
                                            width: "auto",
                                            margin: "auto",
                                            marginBottom: "20px",
                                            marginTop:"30px",
                                            backgroundColor: "#005397",
                                            fontSize: { xs: "15px", md: "20px" }
                                        }}
                                    >
                                        Torna alla Home
                                    </Button>
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Box>

        </>
    );
}